import Image from "next/image"

import { AssetProps } from "./types"

interface RundooWordmarkProps extends AssetProps {
  color: "white" | "black" | "blue"
}

export function RundooWordmark(props: RundooWordmarkProps) {
  return <Image src={workdmarkSrc[props.color]} alt="Rundoo" {...props} />
}

const workdmarkSrc: Record<RundooWordmarkProps["color"], string> = {
  white: "/wordmark-white.svg",
  black: "/wordmark-black.svg",
  blue: "/wordmark-blue.svg",
}
